<ng-container *ngIf="todoListKeys && todoListKeys?.length">
    <!-- Pomoč pri uporabi eAmbulante -->
    <div (click)="expanded = !expanded" class="w-100 p-3 d-flex title-container justify-content-between align-items-center">
        <div></div>
        <div>POMOČ PRI VZPOSTAVITVI eAMBULANTE</div>
        <div class="mr-3">
            <span><a class="la" [ngClass]="{ 'la-angle-down': !expanded, 'la-angle-up': expanded }"></a></span>
        </div>
    </div>
    <div *ngIf="expanded">
        <div class="mb-2 mt-3 row">
            <div class="offset-1 offset-right-1 my-4">
                Pred pričetkom uporabe eAmbulante je potrebno najprej izvesti vse nastavitve, šele nato lahko eAmbulanto uporabljate za tekoče delo
                (rezervacija terminov, izdajanje računov, kreiranje listin, itd.).
                <br />
                Omenjene nastavitve je potrebno izvesti v določenem vrstnem redu.
            </div>
        </div>
        <div class="row justify-content-center">
            <div *ngFor="let section of todoListKeys" class="col-lg-5 col-10 pr-2 pl-2 m-2">
                <div class="m-portlet m-portlet--full-height">
                    <div class="m-portlet__head pl-2">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title d-flex align-items-center">
                                <span class="mr-2 section-icon">
                                    <img *ngIf="section === 'Tehnične nastavitve eAmbulante'" src="../../../../assets/app/media/img/icons/cogs.svg" />
                                    <img
                                        *ngIf="section === 'Nastavitve vezane na aktivne module'"
                                        src="../../../../assets/app/media/img/icons/moduli.svg"
                                    />
                                </span>
                                <span class="ml-1">
                                    <h5 style="font-size: 1.2em" class="m-portlet__head-text">
                                        {{ section }}
                                    </h5>
                                </span>
                            </div>
                        </div>
                        <div class="m-portlet__head-tools">
                            <ul
                                role="tablist"
                                class="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm"
                            ></ul>
                        </div>
                    </div>
                    <div class="m-portlet__body">
                        <div class="ml-2 mb-3">
                            <div *ngFor="let todo of setupTodoList[section]" class="d-flex mr-3 ml-2 my-2 align-items-center">
                                <label class="m-checkbox m-checkbox--solid m-checkbox--single m-checkbox--brand m-0">
                                    <input [checked]="todo?.completed" (change)="changeTodoStatus(todo, $event)" type="checkbox" />
                                    <span></span>
                                </label>
                                <a [routerLink]="helper.getRouteForTodoElement(todo?.id)" (click)="showMessage(todo?.id)" class="task-link">
                                    <span [ngClass]="{ 'line-through': todo?.completed }">
                                        {{ todo.name }}
                                    </span>
                                </a>
                                <span class="arrow-container">
                                    <i class="la la-angle-up link-arrow"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr />
    </div>
</ng-container>
